import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

export function ExtraFieldButton({ label = 'Gerenciar valores extras', openModal, id }) {
  return (
    <Row className="my-2">
      <Col>
        <Button id={id} variant="primary" size="sm" onClick={() => openModal()}>
          <Text color="white" weight={500} type="medium">
            {label}
          </Text>
        </Button>
      </Col>
    </Row>
  );
}
